import {TimelineLite} from "gsap";

export default abstract class AbstractAnimation {

    protected timeline:TimelineLite;
    protected $element:JQuery<HTMLElement>;
    protected params:any;

    public constructor(elem:HTMLElement, options:any = {}, params:any = {}) {
        options.pause = true;
        this.timeline = new TimelineLite(options)
        this.$element = $(elem);
        this.params = params;
    }

    abstract create(): any;

    public run = (onComplete:any = null) => {
        if (onComplete) {
            this.timeline.eventCallback('onComplete', onComplete)
        }
        this.timeline.play()
    }

    public clearTimeline = () =>
        this.timeline.clear() &&
        this.timeline.eventCallback('onComplete', null);

}